import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";

import DataTable from "../../common/DataTable";
import { getChipColor } from "../../../constants/value";
import { dateSortComparator } from "../../../utils/date";

const SearchList = ({ data, meta, loading, isImsi, ...props }) => {
  const nav = useNavigate();
  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      sortable: false,
    },
    {
      field: `${isImsi ? "imsi" : "iccid"}`,
      headerName: `${isImsi ? "IMSI" : "ICCID"}`,
      minWidth: 200,
      flex: 2,
      sortable: false,
    },
    {
      field: "batch_id",
      headerName: "Batch ID",
      minWidth: 300,
      flex: 3,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      handleRowClick={(params) => nav(`batch/${params.row.batch_id}`)}
      disableColumnFilter
      loading={loading}
      data={data}
      columns={columns}
      metaData={meta}
      {...props}
    />
  );
};

export default SearchList;
